import { __exports as r } from "../../../../_virtual/portalOpenInstances.js";
Object.defineProperty(r, "__esModule", {
  value: !0
});
r.log = c;
r.resetState = l;
function i(s, e) {
  if (!(s instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
var a = function s() {
  var e = this;
  i(this, s), this.register = function(n) {
    if (e.openInstances.indexOf(n) !== -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Cannot register modal instance that's already open");
      return;
    }
    e.openInstances.push(n), e.emit("register");
  }, this.deregister = function(n) {
    var t = e.openInstances.indexOf(n);
    if (t === -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Unable to deregister " + n + " as it was never registered");
      return;
    }
    e.openInstances.splice(t, 1), e.emit("deregister");
  }, this.subscribe = function(n) {
    e.subscribers.push(n);
  }, this.emit = function(n) {
    e.subscribers.forEach(function(t) {
      return t(
        n,
        // shallow copy to avoid accidental mutation
        e.openInstances.slice()
      );
    });
  }, this.openInstances = [], this.subscribers = [];
}, o = new a();
function c() {
  console.log("portalOpenInstances ----------"), console.log(o.openInstances.length), o.openInstances.forEach(function(s) {
    return console.log(s);
  }), console.log("end portalOpenInstances ----------");
}
function l() {
  o = new a();
}
r.default = o;
